import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { IReportResult } from "@models/reports/reports";

@Injectable({
  providedIn: "root",
})
export class FileService {
  constructor(@Inject(DOCUMENT) private document: any) {}

  downloadSVG(res: { fileName: string; filePath: string }): void {
    const a = document.createElement("a");
    res.filePath = res.filePath.startsWith("/")
      ? res.filePath
      : `/${res.filePath}`;
    a.href = res.filePath;
    a.setAttribute("target", "_blank");
    a.download = res.fileName;
    a.click();
  }

  public downloadFile(data: any, fileName = "report.xlsx") {
    const blob = this.b64toBlob(data, "application/octet-stream", 512);
    const url = window.URL.createObjectURL(blob);
    const link = this.document.createElement("a");
    link.download = fileName;
    link.href = url;
    link.click();
  }

  private b64toBlob(
    b64Data: string,
    contentType: string,
    sliceSize: number,
  ): Blob {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  public downloadExcelFile(data: IReportResult) {
    const blob = this.b64toBlob(
      data.base64 ?? "",
      "application/octet-stream",
      512,
    );
    const url = window.URL.createObjectURL(blob);
    const link = this.document.createElement("a");

    link.download = data.reportName;
    link.href = url;
    link.click();
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve((reader.result as string).split(",")[1]);
      reader.readAsDataURL(blob);
    });
  }

  blobToSvg(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function (event) {
        const svgText = event.target?.result as string;

        if (svgText.startsWith("<svg")) {
          resolve(svgText);
        } else {
          reject("Blob does not contain valid SVG data");
        }
      };

      reader.onerror = function () {
        reject("Failed to read Blob");
      };

      reader.readAsText(blob);
    });
  }
}
